import { BREAKPOINTS } from "../../../styles/breakpoints";
import { createJpgAndWebpLinks } from "../../_shared-components/image-related/createJpgAndWebpLinks";
import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

export const mobileMediaQueryStr = `(max-width: ${BREAKPOINTS.atLeastMd - 0.05}px)`;
export const desktopMediaQueryStr = `(min-width: ${BREAKPOINTS.atLeastMd}px)`;

const config = {
  mobile: { width: 800, mediaQueryStr: mobileMediaQueryStr },
  desktop: { width: 2000, mediaQueryStr: desktopMediaQueryStr },
};

export const ImageSourceElements: ReactTFC<{
  plainImageUrl: string;
  device: "mobile" | "desktop";
}> = props => {
  const { width, mediaQueryStr } = config[props.device];

  const { jpgLink, webpLink } = createJpgAndWebpLinks(props.plainImageUrl, width);

  return (
    <React.Fragment>
      <source media={mediaQueryStr} srcSet={webpLink} type="image/webp" />
      <source media={mediaQueryStr} srcSet={jpgLink} type="image/jpeg" />
    </React.Fragment>
  );
};
